.overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: min(120px, 15vh);
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    animation: overlayFadeIn 120ms ease-out;
}

@keyframes overlayFadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.modal {
    width: min(640px, calc(100vw - 40px));
    max-height: min(520px, calc(100vh - 200px));
    background-color: var(--white);
    border-radius: 12px;
    box-shadow:
        0 16px 70px rgba(0, 0, 0, 0.2),
        0 0 0 1px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: modalSlideIn 120ms ease-out;
    transition:
        width 200ms ease,
        max-height 200ms ease;
}

.modal--wide {
    width: min(960px, calc(100vw - 40px));
    max-height: min(600px, calc(100vh - 160px));
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: scale(0.98) translateY(-8px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.search-input-container {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--off-white-dk);
}

.search-input-wrapper {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
}

.search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 400;
    color: var(--dark);
    background: transparent;
    line-height: 1.4;
    padding: 0;
    margin: 0;
    position: relative;
    z-index: 1;
}

.search-input::placeholder {
    color: transparent;
}

.placeholder-carousel {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 0;
}

.placeholder-text {
    position: absolute;
    top: 50%;
    left: 0;
    font-size: 16px;
    font-weight: 400;
    font-family: inherit;
    line-height: 1.4;
    color: var(--grey-lt);
    white-space: nowrap;
    padding: 0;
    margin: 0;
}

.placeholder-enter {
    composes: placeholder-text;
    animation: placeholderSlideIn 300ms ease-out forwards;
}

.placeholder-exit {
    composes: placeholder-text;
    animation: placeholderSlideOut 300ms ease-out forwards;
}

@keyframes placeholderSlideIn {
    from {
        transform: translateY(20%);
        opacity: 0;
    }
    to {
        transform: translateY(-50%);
        opacity: 1;
    }
}

@keyframes placeholderSlideOut {
    from {
        transform: translateY(-50%);
        opacity: 1;
    }
    to {
        transform: translateY(-120%);
        opacity: 0;
    }
}

.ghost-text {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 400;
    font-family: inherit;
    line-height: 1.4;
    padding: 0;
    margin: 0;
    color: var(--grey-lt);
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    z-index: 0;
}

.tab-bar {
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid var(--off-white-dk);
    background-color: var(--off-white);
    position: relative;
}

.tab-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 500;
    color: var(--grey);
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition:
        color 150ms ease,
        border-color 150ms ease,
        background-color 150ms ease;
    margin-bottom: -1px;
    border-radius: 6px 6px 0 0;
}

.tab-button:hover {
    color: var(--dark);
    background-color: rgba(0, 0, 0, 0.03);
}

.tab-button:focus-visible {
    outline: 2px solid var(--blue);
    outline-offset: -2px;
    color: var(--dark);
}

.tab-button--active {
    color: var(--blue);
    border-bottom-color: var(--blue);
    background-color: transparent;
}
